import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { ProjetoCadastro } from "../models/projeto-cadastro.model";

@Injectable()
export class ProjetoCadastroService extends BaseService<ProjetoCadastro> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public listFilters(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/list-filters', obj, { headers: this.headers });
  }

  public getProcessFilters(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/process-filters/' + id, { headers: this.headers });
  }

  public listCombos(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-combos', { headers: this.headers });
  }

  public clonar(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/clone', obj, { headers: this.headers });
  }

  public getMenu(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/menu/' + id, { headers: this.headers });
  }

  public getByIdTabs(id: number, obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/tab-custom/' + id, obj, { headers: this.headers });
  }

  public updateTabs(obj: any, id: number): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/tab-custom/' + id, obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/pre-projeto/projeto-cadastro';
  }
}